import React from 'react'
import styled from 'styled-components'
import SectionContainer from 'stories/V1/layouts/SectionContainer'
import FAQItem from 'stories/V1/components/FAQItem'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import theme from 'stories/utils/theme'

const FAQContainer = styled.div`
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    @media ${deviceSize.md} {
        width: 100%;
    }
`

export interface FAQData {
    question: string
    answer: string
}

interface Props {
    faqData: FAQData[]
    title?: string
    backgroundColor?: string
    borderRadius?: string
    mobileBorderRadius?: string
}

const FAQSection = ({ faqData, title, backgroundColor, borderRadius, mobileBorderRadius }: Props) => {
    return (
        <SectionContainer
            title={title ?? 'FAQ'}
            backgroundColor={backgroundColor ?? theme.colors.darkBlackTransparent}
            borderRadius={borderRadius}
            mobileBorderRadius={mobileBorderRadius}
        >
            <FAQContainer>
                {faqData.map((faq, index) => (
                    <FAQItem
                        key={`faq-${index}`}
                        question={faq.question}
                        answer={faq.answer}
                        isOpenByDefault={index === 0}
                    />
                ))}
            </FAQContainer>
        </SectionContainer>
    )
}

export default FAQSection
